var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellnotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1564519_bell_new_note_notifications_icon 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.85013 10H5.10013C4.75013 10 4.45014 10.4 4.65014 10.75C4.95014 11.2 5.45013 11.5 6.00013 11.5C6.55013 11.5 7.05014 11.2 7.30014 10.75C7.50014 10.4 7.25013 10 6.85013 10Z",
    fill: "#9665D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.9001 8.35002L10.7001 8.10002C9.90008 7.05002 9.50008 5.80002 9.50008 4.50002V4.15002C9.50008 2.35002 8.20008 0.750018 6.40008 0.550018C4.30008 0.300018 2.50008 1.95002 2.50008 4.00002V4.50002C2.50008 5.80002 2.10008 7.05002 1.30008 8.10002L1.10008 8.35002C1.00008 8.45002 0.950084 8.65002 1.00008 8.75002C1.15008 9.20002 1.55008 9.50002 2.00008 9.50002H10.0001C10.4501 9.50002 10.8501 9.20002 10.9501 8.75002C11.0001 8.60002 10.9501 8.45002 10.9001 8.35002Z",
    fill: "#9665D3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellnotifications);
export default __webpack_public_path__ + "static/media/bellnotifications.a63533435527e8fa03531f1d739053c3.svg";
export { ForwardRef as ReactComponent };